import React, { useEffect } from 'react'
import {
  Modal, ModalHeader, ModalBody, ModalFooter,
  Button, UncontrolledTooltip, Card
} from 'reactstrap'
import _ from 'lodash'
import ReactTable from 'react-table'

import PageTitle from 'components/PageTitle'
import LoadingOverlay from 'components/Indicator/LoadingOverlay'
import DeleteConfirmation from 'components/Modal/delete'
import Lang from 'Lang/General'

import ProgramModuleForm from './Form'
import WithProgramModulesHOC from './actions.js'

const ProgramModules = props => {
  useEffect( () => {
    props.getProgramModules()
  }, [] )

  useEffect( () => {
    if( !props.showCreateProgramModule ){
      props.onChangeProgramModulesHOC( 
        'newProgramModule', 
        { 
          name: { en: '', de: '', it: '', nl: '' }, 
          description: { en: '', de: '', it: '', nl: '' },
          type: 'events' 
        } 
      )
    }
  }, [ props.showCreateProgramModule ] )

  useEffect( () => {
    if( !props.showUpdateProgramModule ){
      props.onChangeProgramModulesHOC( 'selectedProgramModule', {} )
    }
  }, [ props.showUpdateProgramModule ] )

  const handleSecurityModulesCreate = () => {
    let tmp = _.find( props.data.roleReducer.role.platforms, { name: 'Ark Management' })
    let tmpModules = {}
    if ( tmp ){
      tmpModules = _.find( tmp.modules, { name: 'Member Area' })
      return tmpModules.is_create
    }
  }

  const handleSecurityModulesUpdate = () => {
    let tmp = _.find( props.data.roleReducer.role.platforms, { name: 'Ark Management' })
    let tmpModules = {}
    if ( tmp ){
      tmpModules = _.find( tmp.modules, { name: 'Member Area' })
      return tmpModules.is_update
    }
  }

  const handleSecurityModulesDelete= () => {
    let tmp = _.find( props.data.roleReducer.role.platforms, { name: 'Ark Management' })
    let tmpModules = {}
    if ( tmp ){
      tmpModules = _.find( tmp.modules, { name: 'Member Area' })
      return tmpModules.is_delete
    }
  }

  const renderCreateProgramModuleModal = () => (
    <Modal size='md' isOpen={ props.showCreateProgramModule } >
      <ModalHeader toggle={ () => props.onChangeProgramModulesHOC( 'showCreateProgramModule', false ) } >
        { Lang[ 'CREATE' ][ props.data.languageReducer.lang ] }
      </ModalHeader>
      <ModalBody>
        <ProgramModuleForm
          programModuleType='newProgramModule'
          currentProgramModule={ props.newProgramModule }
          onChangeProgramModulesHOC={ props.onChangeProgramModulesHOC }
          lang={ props.data.languageReducer.lang }
        />
        { props.onLoadProgramModulesHOC && <LoadingOverlay/> }
      </ModalBody>
      <ModalFooter>
        <Button
          color='primary'
          onClick={ () => props.createProgramModule( props.newProgramModule ) }>
          { Lang[ 'SUBMIT' ][ props.data.languageReducer.lang ] }</Button>
      </ModalFooter>
    </Modal>
  )

  const renderUpdateProgramModuleModal = () => (
    <Modal size='md' isOpen={ props.showUpdateProgramModule } >
      <ModalHeader toggle={ () => props.onChangeProgramModulesHOC( 'showUpdateProgramModule', false ) } >
        { Lang[ 'UPDATE' ][ props.data.languageReducer.lang ] }
      </ModalHeader>
      <ModalBody>
        <ProgramModuleForm
          programModuleType='selectedProgramModule'
          currentProgramModule={ props.selectedProgramModule }
          onChangeProgramModulesHOC={ props.onChangeProgramModulesHOC }
          lang={ props.data.languageReducer.lang }
        />
        { props.onLoadProgramModulesHOC && <LoadingOverlay/> }
      </ModalBody>
      <ModalFooter>
        <Button
          color='primary'
          onClick={ () => props.updateProgramModule( props.selectedProgramModule ) }>
          { Lang[ 'SUBMIT' ][ props.data.languageReducer.lang ] }</Button>
      </ModalFooter>
    </Modal>
  )

  return(
    <>
      <PageTitle
        heading={ Lang[ 'PROGRAM_MODULES' ][ props.data.languageReducer.lang ] }
        icon="pe-7s-users icon-gradient bg-happy-fisher"
        buttons={[
          {
            buttonText: Lang[ 'CREATE' ][ props.data.languageReducer.lang ],
            onClick: () => props.onChangeProgramModulesHOC( 'showCreateProgramModule', true ),
            display: handleSecurityModulesCreate()
          }
        ]}/>
      <Card className='p-4'>
        <ReactTable
          showPagination
          pageSize={ 10 }
          data={ props.programModules }
          columns={[
            {
              Header: Lang[ 'NAME' ][ props.data.languageReducer.lang ],
              accessor: "name",
              Cell: ({ value }) => value[ props.data.languageReducer.lang ] 
            },
            {
              Header: Lang[ 'TYPE' ][ props.data.languageReducer.lang ],
              accessor: "type",
              Cell: ({ value }) => Lang[ value.toUpperCase() ][ props.data.languageReducer.lang ] 
            },
            {
              Header: Lang[ 'ACTIONS' ][ props.data.languageReducer.lang ],
              accessor: "id",
              Cell: ({ value }) => (
                <div className='d-flex w-100 justify-content-center' >
                  {
                    handleSecurityModulesUpdate() && (
                      <>
                        <Button
                          id={ `ProgramModule-${ value }-update` }
                          className="mb-2 mr-2 btn-icon btn-icon-only"
                          color="primary"
                          onClick={ () => props.getSelectedProgramModule( value ) }>
                          <i className="pe-7s-note"> </i>
                        </Button>
                        <UncontrolledTooltip
                          target={ `ProgramModule-${ value }-update` }
                          placement="top">{ Lang[ 'EDIT' ][ props.data.languageReducer.lang ] }</UncontrolledTooltip>
                      </>
                    )
                  }
                  {
                    handleSecurityModulesDelete() && (
                      <>
                        <Button
                          id={ `ProgramModule-${ value }-archive-programModule` }
                          className="mb-2 mr-2 btn-icon btn-icon-only"
                          color="danger"
                          onClick={ () => props.onChangeProgramModulesHOC( 'showDeleteProgramModuleId', parseInt( value ) ) }>
                          <i className="pe-7s-trash"> </i>
                        </Button>
                        <UncontrolledTooltip
                          target={ `ProgramModule-${ value }-archive-programModule` }
                          placement="top">{ Lang[ 'REMOVE' ][ props.data.languageReducer.lang ] }</UncontrolledTooltip>
                      </>
                    )
                  }
                </div>
              )
            }
          ]}
        />
      </Card>
      <DeleteConfirmation
        handleModalClose={ () => props.onChangeProgramModulesHOC( 'showDeleteProgramModuleId', 0 ) }
        deleteOpen={ props.showDeleteProgramModuleId > 0 }
        confirmAction={ () => props.removeProgramModule( props.showDeleteProgramModuleId ) }
        content={ Lang[ 'DELETE_CONFIRMATION_PROGRAM_MODULE' ][ props.data.languageReducer.lang ] }
        lang={ props.data.languageReducer.lang } />
      { renderCreateProgramModuleModal() }
      { renderUpdateProgramModuleModal() }
      { props.onLoadProgramModulesHOC && <LoadingOverlay/> }
    </>
  )
}

export default WithProgramModulesHOC( ProgramModules )